import { motion, AnimatePresence } from "framer-motion";
import { Coins, Share2, Loader2 } from "lucide-react";

// 🎉 Arrival celebration — POGZILLA welcomes the POG'R when they roll up.
export const ArrivalCelebration = ({ show, businessName, onClose, onShowQr, onShare, sharing, shareMsg }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        data-testid="arrival-celebration"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 z-[2100] bg-slate-950/95 backdrop-blur-sm flex flex-col items-center justify-center px-6 text-center"
        onClick={onClose}
      >
        <motion.img
          src="/pogzilla.png" alt="POGZILLA"
          initial={{ scale: 0, y: 60, rotate: -12 }}
          animate={{ scale: 1, y: [0, -16, 0], rotate: 0 }}
          transition={{ scale: { type: "spring", stiffness: 260, damping: 14 }, y: { repeat: Infinity, duration: 1.4, ease: "easeInOut" } }}
          className="w-40 h-40 object-contain drop-shadow-[0_0_30px_rgba(52,211,153,0.6)]"
        />
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.25 }}
          className="font-heading text-4xl font-extrabold text-emerald-300 mt-3"
        >
          You made it! 🎉
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }}
          className="text-slate-200 text-base mt-2 max-w-xs"
        >
          You've rolled up to <span className="font-bold text-white">{businessName}</span> — flash your POG code to bank <span className="text-amber-300 font-bold">+30 POG BUCKZ</span>.
        </motion.p>
        <motion.button
          data-testid="arrival-show-qr-btn"
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.55 }}
          onClick={(e) => { e.stopPropagation(); onShowQr(); }}
          className="mt-7 h-14 px-8 rounded-2xl bg-gradient-to-r from-amber-300 to-yellow-500 text-slate-900 font-heading font-extrabold text-lg flex items-center gap-3 hover:opacity-90 transition-opacity shadow-[0_0_30px_rgba(251,191,36,0.5)]"
        >
          <Coins className="w-6 h-6" /> Show your POG code
        </motion.button>
        <motion.button
          data-testid="arrival-share-btn"
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.65 }}
          onClick={(e) => { e.stopPropagation(); onShare(); }}
          disabled={sharing}
          className="mt-3 h-12 px-6 rounded-2xl bg-slate-800/80 border border-slate-600/60 text-slate-100 font-heading font-bold flex items-center gap-2 hover:bg-slate-700 transition-colors disabled:opacity-60"
        >
          {sharing ? <Loader2 className="w-5 h-5 animate-spin" /> : <Share2 className="w-5 h-5 text-sky-300" />} Share this POG moment
        </motion.button>
        {shareMsg && <p data-testid="arrival-share-msg" className="text-xs text-emerald-300 font-semibold mt-3 max-w-xs">{shareMsg}</p>}
        <button
          data-testid="arrival-dismiss-btn"
          onClick={(e) => { e.stopPropagation(); onClose(); }}
          className="mt-4 text-xs text-slate-400 hover:text-slate-200 font-semibold"
        >
          Maybe later
        </button>
      </motion.div>
    )}
  </AnimatePresence>
);
